import instance from '../axios'

const searchApi = {
    search: (query: string, page: number = 1) => {
        return instance.get(`/search`, {
            params: { query, page }
        })
    }
}

export default searchApi
